module.exports = __webpack_public_path__ + "static/the-seven-habits-of-highly-effective-people-7e4b44127d42a3699093acd03447c9a9.jpg";